import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { BCPLockKeyhole } from "../../components/icons/bcp/BCPIcons";
import { isAppMode } from "../../global/AppOverlay";

export default function SubscriptionNotice() {
  const theme = useTheme();
  const appMode = isAppMode();

  return (
    <Box width="100%">
      <Container maxWidth="lg" sx={{ pt: 2, pb: 2 }}>
        <Grid
          container
          sx={{
            p: 2,
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: appMode ? "fixed" : "inherit",
            top: appMode ? "25%" : 0,
          }}
          spacing={1}
        >
          <Grid item xs={12} SX={{ pt: 1, pb: 1 }}>
            <BCPLockKeyhole
              sx={{
                fontSize: "50px",
                width: "50px",
                color: theme?.palette?.text?.disabled,
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h3" sx={{ pt: 2 }}>
              This feature requires an active subscription
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body1" paragraph>
              To access this feature, you may purchase a subscription{" "}
              {appMode ? (
                "within your account settings"
              ) : (
                <Link href="/subscription">here</Link>
              )}
            </Typography>
          </Grid>

          {!appMode && (
            <Grid item xs={6}>
              <Button variant="contained" fullWidth href="/subscription">
                Subscribe now
              </Button>
            </Grid>
          )}
        </Grid>
      </Container>
    </Box>
  );
}
